// src/utils/frameFormats.js

export const DEFAULT_SHOT_FRAME_FORMAT = "16_9";

export const SHOT_FRAME_FORMATS = [
  { value: "1_1", label: "Carré : 1/1", short: "1:1", ratio: 1, css: "1 / 1" },
  { value: "4_3", label: "4/3 - 1:33", short: "4:3", ratio: 4 / 3, css: "4 / 3" },
  { value: "16_9", label: "Standard : 16/9", short: "16:9", ratio: 16 / 9, css: "16 / 9" },
  { value: "9_16", label: "Standard Smartphone : 9/16", short: "9:16", ratio: 9 / 16, css: "9 / 16" },
  { value: "166_1", label: "EU : 1.66:1", short: "1.66:1", ratio: 1.66, css: "166 / 100" },
  { value: "185_1", label: "US : 1.85:1", short: "1.85:1", ratio: 1.85, css: "185 / 100" },
  { value: "235_1", label: "Panavision : 2.35:1", short: "2.35:1", ratio: 2.35, css: "235 / 100" },
  { value: "239_1", label: "Cinemascope : 2.39:1", short: "2.39:1", ratio: 2.39, css: "239 / 100" },
  { value: "golden", label: "Golden Ratio : 1.618:1 (non standard)", short: "1.618:1", ratio: 1.618, css: "1618 / 1000" },
];

// ------------------------------
// Format couleur d'un plan (métadonnée + filtre visuel des vignettes)
// ------------------------------
export const DEFAULT_SHOT_COLOR_FORMAT = "color";

export const SHOT_COLOR_FORMATS = [
  { value: "color", labelKey: "colorFmt.color" },
  { value: "monochrome", labelKey: "colorFmt.monochrome" },
  { value: "bw", labelKey: "colorFmt.bw" },
];

export function getShotColorFormat(value) {
  return (
    SHOT_COLOR_FORMATS.find((c) => c.value === value) ||
    SHOT_COLOR_FORMATS[0]
  );
}

// Format effectif d'un plan : override plan -> réglage scène -> réglage global.
export function effectiveFrameFormatValue(shot, scene, globalFmt) {
  return (
    shot?.frameFormat ||
    scene?.frameFormat ||
    globalFmt ||
    DEFAULT_SHOT_FRAME_FORMAT
  );
}

export function effectiveColorFormatValue(shot, scene) {
  return shot?.colorFormat || scene?.colorFormat || DEFAULT_SHOT_COLOR_FORMAT;
}

export function getColorFormatFilter(value) {
  switch (value) {
    case "bw":
      return "grayscale(1)";
    case "monochrome":
      return "grayscale(1) sepia(0.35)";
    default:
      return "none";
  }
}

const LEGACY_SHOT_FRAME_FORMATS = {
  "5_3": "166_1",
  "240_1": "239_1",
};

export function getShotFrameFormat(value) {
  const normalizedValue = LEGACY_SHOT_FRAME_FORMATS[value] || value;

  return (
    SHOT_FRAME_FORMATS.find((f) => f.value === normalizedValue) ||
    SHOT_FRAME_FORMATS.find((f) => f.value === DEFAULT_SHOT_FRAME_FORMAT) ||
    SHOT_FRAME_FORMATS[0]
  );
}
